import { styled } from "styled-components";

export const PageContainer = styled.div`
  margin: 0 auto;
  max-width: 1440px;
  padding: 40px;
  padding-top: 0;
  @media(max-width: 1000px) {
    padding: 20px;
  }
`